import { render, staticRenderFns } from "./WbtConfigFormFields.vue?vue&type=template&id=6f1759f7&"
import script from "./WbtConfigFormFields.vue?vue&type=script&lang=js&"
export * from "./WbtConfigFormFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports